import { ofType } from "redux-observable";
import { map, switchMap } from "rxjs/operators";
import { TypeActionExpansions } from "../actionExpansions";
import { pathBuyExpansion } from "../paths/pathBuyExpansion";
export var epicExpansionBuyPremiumPurchase = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionExpansions.ConfirmBuyPremium), map(function (action) { return action; }), switchMap(function (action) { return pathBuyExpansion(action, state$, deps); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/epics/epicExpansionBuyPremiumPurchase.ts
// module id = 2096
// module chunks = 3